import React, { useState } from "react";
import { IoIosAddCircle } from "react-icons/io";
// css comes in create_hw_file
// css comes in create_hw_file

const CreateMcq = ({ nextQuestion, question, setQuestions }) => {
  const { options, correct_answers } = question;
  const addOptions = () => {
    setQuestions((prev) => {
      const updatedOptions = [
        ...prev[nextQuestion].options,
        {
          key: String.fromCharCode(options.length + 65),
          value: null,
        },
      ];

      const updatedQuestion = {
        ...prev[nextQuestion],
        options: updatedOptions,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;

      return newQuestions;
    });
  };

  const removeOptions = (index) => {
    setQuestions((prev) => {
      const updatedOptions = prev[nextQuestion].options
        .filter((_, idx) => idx !== index)
        .map((option, i) => ({
          ...option,
          key: String.fromCharCode(65 + i),
        }));

      const updatedQuestion = {
        ...prev[nextQuestion],
        options: updatedOptions,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;

      return newQuestions;
    });
  };

  const handleOptionChange = (index, value) => {
    setQuestions((prev) => {
      const qOptions = prev[nextQuestion].options;
      const updatedOptions = qOptions.map((option, i) =>
        i === index ? { ...option, value: value } : option
      );

      const updatedQuestion = {
        ...prev[nextQuestion],
        options: updatedOptions,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;

      return newQuestions;
    });
  };

  const addMoreCorrectAnswers = () => {
    setQuestions((prev) => {
      const updatedCorrectAnswer = [
        ...prev[nextQuestion].correct_answers,
        {
          option_key: null,
          value: null,
          reason_for_answer: { explanation: null },
        },
      ];

      const updatedQuestion = {
        ...prev[nextQuestion],
        correct_answers: updatedCorrectAnswer,
      };

      const newQuestion = [...prev];
      newQuestion[nextQuestion] = updatedQuestion;
      return newQuestion;
    });
  };

  const removeMoreCorrectAnswers = (index) => {
    setQuestions((prev) => {
      const updatedCorrectAnswer = prev[nextQuestion].correct_answers
        .filter((_, idx) => idx !== index)
        .map((cAnswers, i) => ({
          ...cAnswers,
          reason_for_answer: {
            explanation: cAnswers.reason_for_answer.explanation,
          },
        }));

      const updatedQuestion = {
        ...prev[nextQuestion],
        correct_answers: updatedCorrectAnswer,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;
      return newQuestions;
    });
  };

  const handleCorrectAnswerChange = (index, value) => {
    setQuestions((prev) => {
      const updatedCorrectAnswer = prev[nextQuestion]?.correct_answers.map(
        (answer, i) =>
          i === index
            ? {
                ...answer,
                option_key: value,
                value: options?.filter((obj) => obj?.key === value)[0]?.value,
              }
            : answer
      );

      const updatedQuestion = {
        ...prev[nextQuestion],
        correct_answers: updatedCorrectAnswer,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;
      return newQuestions;
    });
  };

  const handleReasonChange = (index, value) => {
    setQuestions((prev) => {
      const updatedCorrectAnswer = prev[nextQuestion].correct_answers.map(
        (answer, i) =>
          i === index
            ? { ...answer, reason_for_answer: { explanation: value } }
            : answer
      );

      const updatedQuestion = {
        ...prev[nextQuestion],
        correct_answers: updatedCorrectAnswer,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;
      return newQuestions;
    });
  };
  return (
    <>
      {options && options.length > 0 &&
        options?.map((option, index) => (
          <div
            key={index}
            className="d-flex mb-3 mt-3 me-5  hw_mcq_option_box_width "
          >
            <div className="hw_question_no me-2">{option.key}</div>
            <input
              className="hw_mcq_option_box"
              placeholder={"option - " + option.key.toLowerCase()}
              value={option.value}
              onChange={(e) => handleOptionChange(index, e.target.value)}
              maxLength={50}
            />
            <div className="hw_delet_option_icon">
              {options?.length > 2 && (
                <img
                  onClick={() => removeOptions(index)}
                  src="/images/Dustbin.svg"
                  alt=""
                />
              )}
            </div>
          </div>
        ))}

      <div className="d-grid gap-2 d-md-flex justify-content-md-center">
        <button
          onClick={addOptions}
          className="btn  add_question_button"
          type="button"
        >
          <img src="/images/add button.svg" className="mx-1" alt=""></img>
          Add more answer options
        </button>
      </div>
      <div className="ml-1 mb-3 col-12">
        <div className="hw_select_ans ml-1 mb-2">Select the correct answer</div>
        {correct_answers?.length > 0 &&
          correct_answers?.map((cOption, index) => (
            <div key={index} className=" mb-3 col-12 p-0 ">
              <div className="w-100 ">
                <div className="d-flex">
                  <div className=" hw_mcq_answer_option_box ">
                    <div className="col-2 p-0 m-0 hw_select_option_dropdown_size">
                      <select
                        onChange={(e) =>
                          handleCorrectAnswerChange(index, e.target.value)
                        }
                        value={cOption.option_key}
                        label={cOption.option_key}
                        className="form-select select_option_dropdown  py-1 "
                      >
                        <option value="">Option</option>
                        {options?.length > 0 &&
                          options?.map((option, cIndex) => (
                            <option key={cIndex} value={option.key}>
                              {option.key}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-10 hw_correct_ans_option ">
                      {cOption.value}
                    </div>
                  </div>
                  <img
                    onClick={() => removeMoreCorrectAnswers(index)}
                    className="hw_delet_option_icon"
                    src="/images/Dustbin.svg"
                    alt=""
                  ></img>
                </div>

                <div className="hw_mandatory_checkbox ml-1 mt-3">
                  Add reason for correct answer
                </div>
                <div>
                  <input
                    onChange={(e) => handleReasonChange(index, e.target.value)}
                    className="hw_mcq_option_box mt-2 "
                    placeholder="reason for answer"
                    value={cOption.reason_for_answer.explanation}
                    maxLength={100}
                  />
                </div>
              </div>
            </div>
          ))}
      </div>
      {/* ////////////////////////////////////////// */}

      <div className="d-grid gap-2 d-md-flex justify-content-md-center mb-2">
        <button
          onClick={addMoreCorrectAnswers}
          className="btn add_question_button "
          type="button"
        >
          {/* <img src="images/add button.svg" alt="" className="mx-1"/> */}
          <IoIosAddCircle />
          Add more correct answers
        </button>
      </div>
    </>
  );
};

export default CreateMcq;
